import { getHostname, isOfDomain } from '~~/common/js/universal/url-utils';

export const getImageSource = (image) => {
  try {
    const url = new URL(image.hostPageURL);
    return url.hostname;
  } catch (err) {
    return '';
  }
};

export const getImageDimensions = (image) => `${image.width} × ${image.height}`;

export const getImageProxyUrl = ({ contentURL }, size) => {
  try {
    // assembling using the URL object is not possible here,
    // because Imageproxy expects the URL param *not* to be url-encoded
    // and the URL object does the encoding automatically
    const pathname = `${size}x,sc/${contentURL}`;
    return `${process.env.imageproxyUrl}/${pathname}`;
  } catch (err) {
    return contentURL;
  }
};

const videoSourceDomains = [
  'dailymotion.com',
  'vimeo.com',
  'youtube.com',
];

/**
 * Checks if the given image comes from recognised video sites.
 * Also accepts subdomains (e.g. www.youtube.com).
 *
 * @param {Object} image the SRS Image object
 */
export const hasVideoSource = ({ hostPageURL }) => {
  try {
    const hostname = getHostname(hostPageURL);
    const result = videoSourceDomains.some((domain) => isOfDomain(hostname, domain));
    return result;
  } catch (err) {
    return false;
  }
};
